import React from 'react';
import { Radio } from 'antd';
import PropTypes from 'prop-types';

import './styles.scss';

const MyRadio = (props) => {
  const handleChange = (e) => {
    const onChange = props.onChange;
    onChange(e.target.value);
  };

  return (
    <Radio.Group
      onChange={handleChange}
      value={props.value}
      disabled={props.disabled}
    >
      {props.options.map((option) => (
        <div key={option.value}>
          <Radio value={option.value}>
            {option.subTitle && (
              <div className="sub-title">{option.subTitle}</div>
            )}
          </Radio>
        </div>
      ))}
    </Radio.Group>
  );
};

MyRadio.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

MyRadio.defaultProps = {
  name: 'field-name',
  disabled: false,
  options: [
    {
      title: 'Via email',
      subTitle:
        'We will send verification code to your email address hu•••••.com',
      value: 1,
    },
    {
      title: 'Via phone',
      subTitle: 'We will send verification code to your phone number •••••7575',
      value: 2,
    },
  ],
};

export default MyRadio;
